import { Card, Typography } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import CardTitle from "@webapp/components/CardTitle";
import PageWithHeading from "@webapp/components/layout/PageWithHeading";

export const Route = createFileRoute("/_layout/satzung")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageWithHeading title="Satzung des Volleyballclubs Müllheim">
      <Typography>
        <Card>
          <CardTitle>§ 1 Name, Sitz, Geschäftsjahr</CardTitle>
          <ol>
            <li>Der Verein trägt den Namen „Volleyballclub Müllheim e.V“.</li>
            <li>
              Der Verein hat seinen Sitz in Müllheim im Markgräflerland und ist im Vereinsregister
              des Amtsgerichts Freiburg eingetragen unter der Nummer VR 300158
            </li>
            <li>Das Geschäftsjahr des Vereins ist das Kalenderjahr.</li>
            <li>
              Der Verein ist Mitglied des Badischen Sportbundes Süd e.V. und des Südbadischen
              Volleyball Verband.Der Verein und seine Mitglieder anerkennen als für sich
              rechtsverbindlich die Satzungsbestimmungen und Ordnungen dieser Sportverbände in ihrer
              jeweils gültigen Fassung. Der Verein und seine Einzelmitglieder unterwerfen sich der
              Rechtsprechung dieser Verbände und ermächtigen diese, die ihnen überlassenen
              Befugnisse bei der Verfolgung von Verstößen gegen die Satzungen und Ordnungen an
              übergeordnete Verbände zu übertragen. Dies gilt ebenso bei Verstößen gegen die
              Satzungen und Ordnungen der übergeordneten Verbände.
            </li>
            <li>
              Der Verein kann in weiteren Fachverbänden Mitglied werden, deren Sportarten auf
              wettkampf-, breiten- oder freizeitsportlicher Basis betrieben werden. § 1 Abs. 4 gilt
              dann entsprechend. Die Mitgliedschaft in anderen Verbänden und Organisationen, die der
              Erfüllung des Vereinszweckes dienen, ist möglich.
            </li>
          </ol>
          <CardTitle>§ 2 Zweck und Gemeinnützigkeit des Vereins</CardTitle>
          <ol>
            <li>
              Vereinszweck ist die Pflege und Förderung des Sports, besonders des Sports für Kinder
              und Jugendliche. Der Vereinszweck wird insbesondere durch das Abhalten von
              Übungsstunden, die Durchführung von Sportveranstaltungen und die Teilnahme an
              Sportveranstaltungen verwirklicht.
            </li>
            <li>
              Der Verein verfolgt ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne des
              Abschnitts "steuerbegünstigte Zwecke" der Abgabenordnung. Der Verein ist selbstlos
              tätig und verfolgt nicht in erster Linie eigenwirtschaftliche Zwecke.
            </li>
            <li>
              Mittel des Vereins dürfen nur für die satzungsgemäßen Zwecke verwendet werden. Die
              Mitglieder erhalten in ihrer Eigenschaft als Mitglieder des Vereins keine Zuwendungen
              aus Mitteln des Vereins. Es darf keine Person durch Ausgaben, die den Zwecken des
              Vereins fremd sind oder durch unverhältnismäßig hohe Vergütungen begünstigt werden.
            </li>
            <li>
              Die Aufgaben des Vereins werden unter Wahrung der parteipolitischen und
              konfessionellen Neutralität ausgeübt.
            </li>
          </ol>
          <CardTitle>§ 3 Mitgliedschaft</CardTitle>
          <ol>
            <li>
              Mitglied des Vereins kann jede natürliche Person (ordentliche Mitglieder) oder
              juristische Person (außerordentliche Mitglieder) werden.
            </li>
            <li>
              Der Erwerb der Mitgliedschaft setzt einen schriftlichen Aufnahmeantrag auf einem dafür
              vorgesehenen Vordruck voraus, der an ein Mitglied des Vorstands oder die
              Vereinsgeschäftsstelle zu richten ist. Der AufnahmeantragMinderjähriger ist von
              dem/der/den gesetzlichen Vertreter(n)/Vertreterin zu stellen.
            </li>
            <li>
              Über den Aufnahmeantrag entscheidet der Vorstand nach freiem Ermessen. Die Aufnahme
              kann ohne Begründung abgelehnt werden, bedarf jedoch eine Mehrheitsentscheidung des
              Vorstands.
            </li>
            <li>Die Mitgliedschaft beginnt mit der Bestätigung der Aufnahme in Textform.</li>
            <li>
              Personen, die sich um die Förderung des Sports und der Jugend besonders verdient
              gemacht haben, können auf Beschluss des Vorstandes zu Ehrenmitgliedern ernannt werden.
            </li>
          </ol>
          <CardTitle>§ 4 Rechte und Pflichten der Mitglieder</CardTitle>
          <ol>
            <li>
              Mit der Aufnahme in den Verein anerkennt das Mitglied die Satzung. Es verpflichtet
              sich, die Satzungsregelungen und die Ordnungen des Vereins sowie die Beschlüsse der
              Vereinsorgane zu befolgen. Die Mitglieder sind verpflichtet, die Vereinsinteressen zu
              fördern und alles zu unterlassen, was dem Ansehen und dem Zweck des Vereins
              entgegensteht.
            </li>
            <li>
              Die Mitglieder sind berechtigt, die Einrichtungen und Anlagen des Vereins entsprechend
              den geltenden Benutzungsordnungen zu benutzen und an allen Veranstaltungen des Vereins
              teilzunehmen.
            </li>
            <li>
              Stimmberechtigt bei der Mitgliederversammlung sind Mitglieder ab dem vollendeten 16.
              Lebensjahr. Sie üben dieses Recht persönlich aus. Außerordentliche Mitglieder haben
              ebenfalls nur eine Stimme, die von einem Vertreter wahrgenommen wird. Wird der fällige
              Mitgliedsbeitrag nicht bezahlt, ruht das Stimmrecht des Mitglieds.
            </li>
            <li>
              Die Mitglieder sind verpflichtet, den Verein über Änderungen in ihren persönlichen
              Verhältnissen schriftlich zu informieren. Dazu gehört insbesondere:
            </li>
            <li>die Mitteilung von Anschriftenänderungen</li>
            <li>Änderung der Bankverbindung bei der Teilnahme am Einzugsverfahren</li>
            <li>
              Mitteilung von persönlichen Veränderungen, die für das Beitragswesen relevant sind
              (z.B. Beendigung der Schulausbildung, etc.).
            </li>
            <li>
              Nachteile, die dem Mitglied dadurch entstehen, dass es dem Verein die erforderlichen
              Änderungen nach Abs. 4 nicht mitgeteilt hat, gehen nicht zu Lasten des Vereins und
              können diesem nicht entgegengehalten werden. Entsteht dem Verein dadurch ein Schaden,
              ist das Mitglied zum Ausgleich verpflichtet.
            </li>
          </ol>
          <CardTitle>§ 5 Mitgliedsbeiträge</CardTitle>
          <ol>
            <li>
              Die Mitglieder sind zur Entrichtung der durch die Mitgliederversammlung festgesetzten
              Beiträge, Umlagen und Gebühren verpflichtet. Einzelheiten werden in der
              Beitragsordnung geregelt.
            </li>
            <li>
              Der Vorstand kann in begründeten Einzelfällen Beiträge ganz oder teilweise stunden
              oder erlassen.
            </li>
            <li>
              Der Verein ist bei besonderen Vorhaben mit außergewöhnlich hohen Kosten oder zur
              Beseitigung finanzieller Schwierigkeiten des Vereins zur Erhebung einmaliger Umlagen
              berechtigt, sofern diese zur Finanzierung notwendig sind. Über die Festsetzung der
              Höhe der Umlage entscheidet die Mitgliederversammlung, wobei eine Höchstgrenze besteht
              von dem zweifachen eines Jahresbeitrages.
            </li>
          </ol>
          <CardTitle>§ 6 Beendigung der Mitgliedschaft</CardTitle>
          <ol>
            <li>
              Die Mitgliedschaft erlischt durch Tod (bei jurist. Personen durch Erlöschen der
              Rechtsfähigkeit) – eine Vererbung findet nicht statt –, durch freiwilligen Austritt,
              durch Streichung von der Mitgliederliste oder durch Ausschluss aus dem Verein.
              Verpflichtungen dem Verein gegenüber sind bis zum Ablauf des laufenden Geschäftsjahres
              zu erfüllen.
            </li>
            <li>
              Der freiwillige Austritt hat in Textform gegenüber einem Mitglied des Vorstands oder
              der Vereinsgeschäftsstelle erfolgen. Er ist frühestens zum Ende des dem Eintritt
              folgenden Kalenderjahres unter Einhaltung einer Kündigungsfrist von einem Monat
              zulässig.
            </li>
            <li>
              Ein Mitglied kann durch Beschluss des Vorstandes von der Mitgliederliste gestrichen
              werden, wenn es trotz zweimaliger Mahnung mit der Zahlung des Beitrags im Rückstand
              ist. Die Streichung darf erst beschlossen werden, nachdem seit der Absendung des
              zweiten Mahnschreibens drei Monate verstrichen und die Beitragsschulden nicht
              beglichen sind. Eine Streichung ist auch möglich, wenn das Mitglied dem Verein länger
              als sechs Monate keinerlei aktuelle Kontaktdaten zur Verfügung stellt.
            </li>
            <li>
              Ein Mitglied kann aus dem Verein ausgeschlossen werden, wenn ein wichtiger Grund
              vorliegt. Der Ausschluss erfolgt durch Beschluss des Vorstandes in einer Sitzung, bei
              der mindestens die Hälfte der Mitglieder des Vorstandes anwesend sein muss.
              Ausschließungsgründe sind insbesondere
            </li>
            <ul>
              <li>
                Grober oder wiederholter Verstoß des Mitglieds gegen die Satzung, gegen Ordnungen
                oder gegen Beschlüsse des Vereins
              </li>
              <li>Schwere Schädigung des Ansehens des Vereins.</li>
              <li>Unehrenhaftes Verhalten und bei Aberkennung der Bürgerrechte</li>
            </ul>
            <p>
              Vor der Beschlussfassung über den Ausschluss ist dem Mitglied unter Setzung einer
              angemessenen Frist Gelegenheit zu geben, sich persönlich vor dem Vorstand oder
              schriftlich zu rechtfertigen. Das Verfahren legt der Vorstand fest. Die Entscheidung
              über den Ausschluss ist schriftlich zu begründen und dem Mitglied bekannt zu machen.
              Gegen die Entscheidung des Vorstandes kann das Mitglied Berufung an die
              Mitgliederversammlung einlegen. Die Berufung muss innerhalb einer Frist von einem
              Monat ab Zugang des Ausschließungsbeschlusses beim Vorstand schriftlich eingelegt
              werden. Ist die Berufung rechtzeitig eingelegt, so entscheidet die nächste ordentliche
              Mitgliederversammlung.
            </p>
          </ol>
          <CardTitle>§ 7 Organe des Vereins</CardTitle>
          <ol>
            <li>Organe des Vereins sind:</li>
            <ul>
              <li>die Mitgliederversammlung</li>
              <li>der Vorstand</li>
              <li>der Vorstand im Sinne von § 26 BGB.</li>
            </ul>
            <li>
              Die Vereins- und Organämter werden grundsätzlich ehrenamtlich ausgeübt. Bei Bedarf
              können Vereins- und Organämter im Rahmen der haushaltsrechtlichen Möglichkeiten gegen
              Zahlung einer Aufwandsentschädigung nach § 3 Nr. 26 a EStG ausgeübt werden. Die
              Entscheidung über eine solche entgeltliche Tätigkeit trifft die Mitgliederversammlung
              auf Vorschlag des Vorstandes.
            </li>
            <li>
              Die Mitglieder und Mitarbeiter des Vereins haben einen Ersatzanspruch nach § 670 BGB
              für solche Aufwendungen, die ihnen durch die Tätigkeit für den Verein entstanden sind
              (z. B. Reisekosten, Porto, Telefon). Der Anspruch auf Aufwendungsersatz kann nur
              innerhalb einer Frist von sechs Monaten nach Entstehung geltend gemacht werden.
            </li>
          </ol>
          <CardTitle>§ 8 Mitgliederversammlung</CardTitle>
          <ol>
            <li>
              In jedem Kalenderjahr ist eine Mitgliederversammlung durchzuführen. Sie wird vom
              Vorstand unter Einhaltung einer Frist von drei Wochen unter Angabe der Tagesordnung
              einberufen. Die Einladung gilt dem Mitglied als zugegangen, wenn es an die letzte vom
              Mitglied dem Verein bekannt gegebene Adresse gerichtet ist. Die textliche
              Einladungsform ist auch gewahrt, wenn die Einladung per E-Mail erfolgt. § 8 Abs. 1
              Satz 3 gilt entsprechend. Die endgültige Tagesordnung und die Beschlussvorlagen werden
              spätestens eine Woche vor der Mitgliederversammlung auf der Internetseite des Vereins
              oder mittels Vereinssoftware veröffentlicht.
            </li>
            <li>
              Anträge zur ordentlichen Mitgliederversammlung müssen spätestens 7 Tage vor der
              Versammlung in Textform mit Begründung bei einem der Vorstandsmitglieder eingereicht
              werden.
            </li>
            <li>Die Mitgliederversammlung wird von einem der Vorstände geleitet.</li>
            <li>
              Die Mitgliederversammlung ist ohne Rücksicht auf die Zahl der erschienenen Mitglieder
              beschlussfähig. Die Beschlussfassung erfolgt durch Mehrheit der abgegebenen gültigen
              Stimmen. Ungültige Stimmen und Stimmenhaltungen werden protokolliert, bleiben aber
              unberücksichtigt. Eine geheime Beschlussfassung erfolgt, wenn dies von 10% der
              anwesenden Stimmberechtigten beantragt wird. Bei finanziellen Beschlussfassungen,
              benötigt es den Antrag zur geheimen Abstimmung von nur einer Person.
            </li>
            <li>
              Beschlüsse über Satzungsänderungen bedürfen einer Mehrheit von zwei Dritteln der
              abgegebenen gültigen Stimmen. Ungültige Stimmen und Stimmenhaltungen werden
              protokolliert, bleiben aber unberücksichtigt. Abweichend davon bedürfen Beschlüsse
              über eine Änderung des Zweckes des Vereins einer Mehrheit von drei Vierteln der
              abgegebenen Stimmen.
            </li>
            <li>
              Über die Beschlüsse der Mitgliederversammlung ist ein Protokoll aufzunehmen, das vom
              jeweiligen Versammlungsleiter und dem Protokollführer zu unterzeichnen ist.
            </li>
            <li>
              Eine außerordentliche Mitgliederversammlung muss einberufen werden, wenn 20 % der
              Mitglieder des Vereins es schriftlich unter Angabe der Gründe beim Vorstand
              beantragen. Ferner kann der Vorstand jederzeit eine außerordentliche
              Mitgliederversammlung einberufen, er muss dies, wenn das Interesse des Vereins es
              erfordert. Für die Einladung und Durchführung einer außerordentlichen
              Mitgliederversammlung gelten die Vorschriften der Abs. 1 bis 6 entsprechend.
            </li>
            <li>
              Der Vorstand kann zu einer virtuellen oder hybriden Mitgliederversammlung einladen.
              Wird eine hybride oder virtuelle Versammlung einberufen, so muss bei der Berufung auch
              angegeben werden, wie die Mitglieder ihre Rechte im Wege der elektronischen
              Kommunikation ausüben können.
            </li>
          </ol>
          <CardTitle>§ 9 Zuständigkeit der Mitgliederversammlung</CardTitle>
          <p>Die Mitgliederversammlung hat folgende Aufgaben:</p>
          <ol>
            <li>Entgegennahme der Jahresberichte des Vorstands</li>
            <li>Entgegennahme der Berichte der Kassenprüfer/innen</li>
            <li>Entlastung des Vorstands</li>
            <li>Bekanntgabe des vom Vorstand aufgestellten Haushaltsplans</li>
            <li>Wahl des Vorstands</li>
            <li>Wahl der Kassenprüfer/innen</li>
            <li>Beratung und Beschlussfassung über vorliegende Anträge</li>
            <li>
              Beschlussfassung über die Gewährung einer Aufwandsentschädigung nach § 3 Nr. 26 a EstG
            </li>
            <li>
              Beschlussfassung über Satzungsänderungen, Änderungen des Vereinszweckes und Auflösung
              des Vereins.
            </li>
            <li>Beschlussfassung über Berufungen gegen einen Vereinsausschluss</li>
            <li>
              Verabschiedung der Beitragsordnung mit Festsetzung der Beiträge und
              Fälligkeitszeitpunkte gem. § 5 Abs. 1
            </li>
            <li>Bestätigung der von der Jugendversammlung beschlossenen Jugendordnung</li>
          </ol>
          <CardTitle>§ 10 Vorstand</CardTitle>
          <ol>
            <li>
              Der Vorstand des Vereins besteht aus:
              <ol>
                <li>Vorsitzenden</li>
                <li>stellvertretenden Vorsitzenden</li>
                <li>Kassenwart</li>
                <li>Schriftführer</li>
                <li>Beisitzer</li>
                <li>Beisitzer</li>
              </ol>
            </li>
            <li>
              Gesetzliche Vertreter gem. § 26 BGB sind der 1. Vorsitzende und der stellvertretende
              Vorsitzende. Beide sind für sich alleine vertretungsberechtigt.
            </li>
            <li>
              Die Mitglieder des Vorstandes werden von der Mitgliederversammlung für die Dauer von
              zwei Jahren, vom Tage der Wahl angerechnet, gewählt. Sie bleiben jedoch bis zur
              Durchführung einer Mitgliederversammlung nach Ablauf der Wahlperiode oder bis zur
              Wiederwahl im Amt. Eine geheime Wahl erfolgt, wenn dies von einer der anwesenden
              Stimmberechtigten beantragt wird. Die beiden Vorstände gem.§ 26 BGB sind einzeln zu
              wählen.
            </li>
            <li>
              Wählbar in den Vorstand sind Mitglieder ab dem vollendeten 16. Lebensjahr. Wählbar als
              Vorstand nach § 26 BGB sind Mitglieder ab dem vollendeten 18. Lebensjahr.
            </li>
            <li>
              Der Vorstand leitet und führt den Verein nach Maßgabe dieser Satzung und der
              Ordnungen. Es ist für sämtliche Vereinsangelegenheiten zuständig, soweit die Satzung
              diese nicht ausdrücklich einem anderen Organ zugewiesen hat. Zur Erledigung der
              Geschäftsführung und zur Führung einer Geschäftsstelle ist der Vorstand ermächtigt, im
              Rahmen der haushaltsrechtlichen Möglichkeiten hauptamtlich Beschäftigte anzustellen.
            </li>
            <li>
              Die Sitzungen des Vorstandes finden entweder real oder virtuell (online) bzw. hybrid
              in einem nur für die Vorstandsmitglieder zugänglichen Verfahren statt.Ein
              Vorstandsmitglied lädt unter Angabe der Tagesordnung mit angemessener Frist zu diesen
              ein. Der Vorstand ist beschlussfähig, wenn mindestens die Hälfte seiner Mitglieder,
              darunter ein nach § 26 BGB vertretungsberechtigtes Mitglied, anwesend sind. Der
              Vorstand fasst seine Beschlüsse mit der Mehrheit der abgegebenen gültigen Stimmen.
              Ungültige Stimmen und Stimmenthaltungen werden protokolliert, bleiben aber
              unberücksichtigt. Der Vorstand kann Beschlüsse auch im Umlaufverfahren per Textform
              (§126 b BGB) fassen, es sei denn, dass drei Mitglieder des Vorstandes einer
              Beschlussfassung durch Umlaufbeschluss widersprechen. Die Beschlüsse des Vorstandes
              (auch solche, die im Wege eines Umlauf-Beschlusses gefasst sind) sind zu
              protokollieren.
            </li>
            <li>
              Bei vorzeitigem Ausscheiden eines Mitglieds des Vorstands kann der Vorstand bis zum
              Ablauf der regulären Wahlperiode ein Ersatzmitglied wählen; dies muss in einer Sitzung
              erfolgen.
            </li>
            <li>
              Durch Beschluss des Vorstands können für definierte Aufgaben Ausschüsse gebildet
              werden, die von einem Mitglied des Vorstandes geleitet werden. Der Vorstand beruft die
              Mitglieder der Ausschüsse.
            </li>
            <li>
              Die Verteilung der Zuständigkeitsbereiche regeln die Mitglieder des Vorstandes
              untereinander. Die Zuständigkeiten werden ineinem Geschäftsverteilungsplan
              festgehalten und den Mitgliedern spätestens sechs Wochen nach der Wahl durch
              Veröffentlichung auf der Homepage des Vereins oder mittels Vereinssoftware kenntlich
              gemacht. Zuständigkeitsänderungen sind jederzeit möglich und unverzüglich zu
              veröffentlichen.
            </li>
            <li>
              Die Vorstandsmitglieder sind alleine vertretungsberechtigt. Bei Grundstücksgeschäften
              im Wert von über 5.000 € wird der Verein durch zwei Vorstandsmitglieder gem. § 26 BGB
              gemeinsam vertreten.
            </li>
            <li>
              Der Vorstand gem. § 26 BGB kann bei Bedarf, aufgabenbezogen oder für einzelne
              Projekte, besondere Vertreter nach § 30 BGB bestellen.
            </li>
          </ol>
          <CardTitle>§ 11 Vereinsjugend</CardTitle>
          <ol>
            <li>
              Die Vereinsjugend ist die Jugendorganisation des Vereins. Ihr gehören alle
              jugendlichen Mitglieder bis zum vollendeten 18. Lebensjahr, sowie die gewählten
              Mitglieder des Jugendausschusses an.
            </li>
            <li>
              Die Vereinsjugend führt und verwaltet sich selbständig und entscheidet über die ihr
              zufließenden Mittel unter Berücksichtigung der Gemeinnützigkeit des Vereins.
            </li>
            <li>
              Die Vereinsjugend gibt sich eine Jugendordnung. Stimmberechtigt ist, wer das zehnte
              Lebensjahr vollendet hat. Die Jugendordnung bedarf der Bestätigung durch die
              Mitgliederversammlung.
            </li>
          </ol>
          <CardTitle>§ 12 Kassenprüfer</CardTitle>
          <ol>
            <li>
              Die Mitgliederversammlung wählt aus dem Kreis der stimmberechtigten Mitglieder zwei
              Kassenprüfer, die nicht dem Vorstand angehören dürfen. Die Amtsdauer der Kassenprüfer
              beträgt zwei Jahre. Sie bleiben jedoch bis zur gültigen Wahl der Nachfolger im Amt.
            </li>
            <li>
              Die Kassenprüfer prüfen mindestens einmal jährlich vor der Mitgliederversammlung die
              sachliche und rechnerische Richtigkeit der gesamten Vereinskasse mit allen Konten,
              Buchungsunterlagen und Belegen und erstatten dem Vorstand und der
              Mitgliederversammlung darüber einen Bericht. Der Vorstand kann jederzeit eine
              außerordentliche Kassenprüfung anordnen.
            </li>
            <li>
              Bei ordnungsgemäßer Führung der Kassengeschäfte beantragen die Kassenprüfer die
              Entlastung des Vorstands im Rahmen der Mitgliederversammlung.
            </li>
            <li>
              Bei vorzeitigem Ausscheiden eines Kassenprüfers kann der Vorstand bis zur nächsten
              Mitgliederversammlung einen Ersatzkassenprüfer kommissarisch berufen.
            </li>
          </ol>
          <CardTitle>§ 13 Haftung</CardTitle>
          <ol>
            <li>
              Alle für den Verein tätige Personen, deren Vergütung den Ehrenamtsfreibetrag gem. § 3
              Nr. 26 a EstG im Jahr nicht übersteigt, haften für Schäden gegenüber den Mitgliedern
              und gegenüber dem Verein, die sie in Erfüllung ihrer ehrenamtlichen Tätigkeit
              verursachen, nur für Vorsatz und grobe Fahrlässigkeit.Werden diese Personen von
              Dritten im Außenverhältnis zur Haftung herangezogen, ohne dass Vorsatz oder grobe
              Fahrlässigkeit vorliegt, so haben diese gegen den Verein einen Anspruch auf Ersatz
              ihrer Aufwendungen zur Abwehr der Ansprüche sowie auf Freistellung von Ansprüchen
              Dritter.
            </li>
            <li>
              Der Verein haftet gegenüber den Mitgliedern im Innenverhältnis nicht für fahrlässig
              verursachte Schäden, die Mitglieder bei der Ausübung des Sports, bei Benutzung von
              Anlagen oder Einrichtungen des Vereins oder bei Vereinsveranstaltungen erleiden,
              soweit solche Schäden nicht durch Versicherungen des Vereins abgedeckt sind.
            </li>
          </ol>
          <CardTitle>§ 14 Datenschutz im Verein</CardTitle>
          <ol>
            <li>
              Zur Erfüllung der Zwecke und Aufgaben des Vereins werden unter Beachtung der
              gesetzlichen Vorgaben der Datenschutz-Grundverordnung (DSGVO) der EU und des
              Bundesdatenschutzgesetzes (BDSG) personenbezogene Daten über persönliche und sachliche
              Verhältnisse der Mitglieder im Verein gespeichert und verarbeitet. Einzelheiten regelt
              der Vorstand erforderlichenfalls in einer Datenschutzrichtlinie.
            </li>
            <li>
              Die Rechte der Mitglieder hinsichtlich ihrer personenbezogenen Daten richten sich nach
              der Datenschutzgrundverordnung und dem Bundesdatenschutzgesetz in der jeweils gültigen
              Fassung.
            </li>
            <li>
              Allen für den Verein tätigen Personen ist es untersagt, personenbezogene Daten
              unbefugt zu anderen als dem zur jeweiligen Aufgabenerfüllung gehörenden Zweck zu
              verarbeiten, bekannt zu geben, Dritten zugänglich zu machen oder sonst zu nutzen.
              Diese Pflicht besteht auch über das Ausscheiden der oben genannten Personen aus dem
              Verein hinaus.
            </li>
          </ol>
          <CardTitle>§ 15 Auflösung</CardTitle>
          <ol>
            <li>
              Die Auflösung des Vereines kann nur in einer Mitgliederversammlung beschlossen werden,
              bei deren Einberufung die Beschlussfassung über die Vereinsauflösung den Mitgliedern
              angekündigt ist.
            </li>
            <li>
              Der Beschluss über die Auflösung des Vereins bedarf der Mehrheit von drei Vierteln der
              abgegebenen Stimmen. Ungültige Stimmen und Stimmenthaltungen bleiben unberücksichtigt.
            </li>
            <li>
              Bei Auflösung des Vereins oder bei Wegfall steuerbegünstigter Zwecke fällt das
              Vereinsvermögen an eine juristische Person des öffentlichen Rechts oder eine andere
              steuerbegünstigte Körperschaft zwecks Verwendung für die Förderung des Sports. Den
              notwendigen Beschluss fasst die Mitgliederversammlung.
            </li>
          </ol>
          <CardTitle>§ 16 In-Kraft-Treten</CardTitle>
          <ol>
            <li>
              Diese Satzung wurde in der ordentlichen Mitgliederversammlung vom 15.11.23 mit der
              erforderlichen Mehrheit beschlossen. Sie tritt mit Eintragung im Vereinsregister in
              Kraft. Die Satzung vom 03.04.1987 tritt am selben Tage außer Kraft.
            </li>
            <li>
              Die Wahlen bei der Mitgliederversammlung vom 15.11.23 können bereits nach Maßgabe von
              §§ 8-10 dieser Satzung durchgeführt werden.
            </li>
            <li>
              Im Falle von Beanstandungen durch das Registergericht bzw. Finanzamt wird der Vorstand
              ermächtigt, durch geeignete Änderungen bzw. Ergänzungen der Satzung das
              Eintragungshindernis bzw. die Beanstandung zu beseitigen. In der auf den Beschluss
              folgenden Mitgliederversammlung ist diese von der Satzungsänderung in Kenntnis zu
              setzen.
            </li>
          </ol>
        </Card>
      </Typography>
    </PageWithHeading>
  );
}
